import type { ComboboxProps } from '../Combobox';

export function assertSingleSelect<
  TValue extends string,
  TMultiselect extends boolean,
>({
  multiselect,
  value,
  displaySelectedOptions,
  maxSelectedOptions,
}: Pick<
  ComboboxProps<TValue, TMultiselect>,
  'multiselect' | 'value' | 'displaySelectedOptions' | 'maxSelectedOptions'
>): void {
  if (multiselect) {
    return;
  }

  if (displaySelectedOptions) {
    console.warn(
      'displaySelectedOptions is only available for multiselect combobox',
    );
  }

  if (Array.isArray(value)) {
    throw new Error("value can't be an array for single select combobox");
  }

  if (maxSelectedOptions !== undefined) {
    throw new Error(
      'maxSelectedOptions is only available for multiselect combobox',
    );
  }
}
